import { OverlayRef } from '@angular/cdk/overlay';
import { InjectionToken } from '@angular/core';

export const TUTORIAL_BUTTON_DATA = new InjectionToken('TUTORIAL_BUTTON_DATA');

export class TutorialButtonRef {
  constructor(private overlayRef: OverlayRef) { }

  public close(): void {
    this.overlayRef.dispose();
  }
}
